import Notifications from 'vue-notification/dist/ssr.js'
import Vue from 'vue'

Vue.use(Notifications)
